import PropTypes from "prop-types"
import { TableCell } from "@mui/material"
import { KeyboardArrowLeft } from "@mui/icons-material"
import { size } from "lodash"
import TableDropdown from "components/table-dropdown"
import classNames from "classnames"
import "./styles.scss"

function ContributorsTableHead(
  {
    label,
    color,
    onBackClick,
    dropdownColumns,
    dropdownItems,
    onDropdownItemClick,
    selectedItemId,
    formatter,
  }) {
  return (
    <TableCell className="components_contributors-table-head">
      <div className="selected-label-wrapper" style={{ color }} title={label}>
        {!!onBackClick && <a className="back-button" onClick={onBackClick}><KeyboardArrowLeft /></a>}
        <div className={classNames("selected-label", { noarrow: !onBackClick })}>
          {!size(dropdownItems)
            ? <div className="label">{label}</div>
            : <TableDropdown
                label={label}
                columns={dropdownColumns}
                items={dropdownItems}
                onItemClick={onDropdownItemClick}
                selectedItemId={selectedItemId}
                formatter={formatter}
            />}
        </div>
      </div>
    </TableCell>
  )
}

ContributorsTableHead.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  onBackClick: PropTypes.func,
  dropdownColumns: PropTypes.array,
  dropdownItems: PropTypes.array,
  onDropdownItemClick: PropTypes.func,
  selectedItemId: PropTypes.string,
  formatter: PropTypes.func,
}

export default ContributorsTableHead
